<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="d-flex flex-row align-items-baseline aside-header">
    <h3 class="mr-auto">{{saveText}} User Account</h3>
    <button mat-raised-button (click)="save()" class="mr-2" color="primary">{{saveText}}</button>
    <button mat-raised-button (click)="cancel()">Cancel</button>
  </div>
  <div>
    <div>
      <mat-form-field>
        <mat-label>First Names</mat-label>
        <input formControlName="firstNames" matInput/>
      </mat-form-field>
      @if (firstNames.touched && !firstNames.valid) {
        <mat-error>
          First names is required
        </mat-error>
      }
    </div>
    <div>
      <mat-form-field>
        <mat-label>Last names</mat-label>
        <input formControlName="lastName" matInput  />
      </mat-form-field>
      @if (lastName.touched && !lastName.valid) {
        <mat-error>
          Last name is required
        </mat-error>
      }
    </div>
    <div>
      <mat-form-field>
        <mat-label>Username</mat-label>
        <input formControlName="username" matInput  />
      </mat-form-field>
      @if (username.touched && !username.valid) {
        <mat-error>
          Username is required
        </mat-error>
      }
    </div>
    @if (!editMode) {
      <div>
        <mat-form-field>
          <mat-label>Password</mat-label>
          <input type="password" formControlName="password" matInput  />
        </mat-form-field>
        @if (password.touched && !password.valid) {
          <mat-error>
            Password is required and must be a minimum of 8 characters containing at least one letter and at least one number
          </mat-error>
        }
      </div>
    }
    @if (!editMode) {
      <div>
        <mat-form-field>
          <mat-label>Confirm Password</mat-label>
          <input type="password" formControlName="confirmPassword" matInput
            />
          </mat-form-field>
          @if (confirmPassword.touched && confirmPassword.errors?.required) {
            <mat-error>
              Confirm Password is required
            </mat-error>
          }
          @if (confirmPassword.errors?.passwordMismatch) {
            <mat-error>
              Passwords must match
            </mat-error>
          }
        </div>
      }
      <div class="d-flex flex-row">
        <label for="roles">Assigned Roles</label>
        <div formArrayName="roles" class="col-sm-8 col-lg-8">
          @for (role of roleControls.controls; track role; let i = $index) {
            <div>
              <mat-checkbox [formControlName]="i" (change)=roleChanged()>{{this.viewModel.roles[i].display}}</mat-checkbox>
            </div>
          }
          @if (dataForm.errors?.noRoleSelected) {
            <mat-error>
              A user must be assigned to a role
            </mat-error>
          }
        </div>
      </div>
    </div>
  </div>
